import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const DevResourceViewerSection = ({ value, children }) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
    >
      <Text
        variant={'h6'}
        color={'black'}
        value={value}
        weight={'bold'}
        component={'span'}
        align={'start'}
      />
      {children}
    </Box>
  );
};

DevResourceViewerSection.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default DevResourceViewerSection;
